<template>
  <main class="page-operative page-operative-settings">
    <div class="container">
      <PageTitle class="mb-5">Utenti</PageTitle>
        <button class="btn btn-outline-primary mb-4" @click="addUserModal.show()">
          <i class="fas fa-user-plus mr-1"></i>
          Aggiungi nuovo
        </button>

        <BModal title="Invita" dialog-class="modal--type-dialog" id="invite-company-modal" ref="invite-company-modal" hide-footer centered scrollable>
          <p>
            Invita un utente sull'azienda {{company.name}}
            <br />
            Deve accettare il tuo invito per poter accedere alla piattaforma
          </p>
          <ReservationForm :user="{ company: company.id }" :roles="rolesPerUser" @success="onReservedUser" />
        </BModal>
        <div v-if="users.length > 0" class="row">
          <div v-for="user in users" :key="user.id" class="col-lg-4 pb-4">
            <LawaCard class="h-100">
              <h4 class="mb-4" :class="{ 'text-muted': !user.active }">
                {{user.active ? user.name + ' ' + user.surname : user.email}}
              </h4>
              <p class="mb-1">
                <strong>Ruolo: </strong>
                <span class="text-capitalize">
                  {{ user.role }}
                </span>
              </p>
              <p class="mb-1">
                <strong class="text-dark">Stato: </strong>

                <i :class="[ !user.active ? 'fas fa-hourglass-half text-warning' : 'fas fa-check text-success' ]"></i>
                {{user.active ? 'Attivo dal ' + user.activationDate : 'In attesa di accettazione'}}
              </p>
              <p class="mb-1">
                <strong>Email: </strong>
                <span>
                  {{ user.email }}
                </span>
              </p>
              <template #footer>
                <AwlConfirm
                  v-if="!user.active"
                  class="btn btn-block text-left"
                  status='outline-danger btn'
                  title='Elimina invito'
                  @confirm="deleteReservation(user)"
                >
                  Sei sicuro di voler eliminare l'invito per l'utente {{ user.name }} {{ user.surname }} per questa azienda?
                </AwlConfirm>
                <AwlConfirm
                  v-if="user.active && (!['admin', 'consultant', 'owner'].includes(user.role) || userIsContextCompanyConsultant || userIsAdmin)"
                  class="btn text-left"
                  status='outline-danger '
                  title='Elimina'
                  @confirm="deleteUserForCompany(user)"
                >
                  Sei sicuro di voler eliminare l'utente {{ user.name }} {{ user.surname }} per questa azienda?
                </AwlConfirm>
                <button class="btn btn-block btn-primary align-self-center m-0" @click="reserve(user)" v-if="!user.active">
                  <i class="fas fa-share mr-1"></i>
                  Rimanda invito
                </button>
              </template>
            </LawaCard>
          </div>
        </div>
      <!--<div v-if="feedback === true" class="alert alert-success">Impostazioni salvate</div>-->

    </div>
  </main>
</template>

<script>

import { BModal } from 'bootstrap-vue';
import operativeContextRolesMixin from '@/mixins/operativeContextRoles.js';
import $api from '@/libs/Api/services/api.js';
import operativePageMixin from '@/mixins/operativePage';

export default {
  name: 'Users',
  mixins: [operativePageMixin, operativeContextRolesMixin],
  components: {
    BModal,
    LawaCard: () => import('@/views/components/Layout/Card/LawaCard.vue'),
    ReservationForm: () => import('@/views/components/Account/ReservationForm.vue'),
    PageTitle: () => import('@/views/components/Layout/LayoutOperative/PageTitle'),
    AwlConfirm: () => import('@/libs/Modals/components/AwlConfirm'),
  },
  data () {
    return {
      users: {},
    };
  },
  computed: {
    rolesPerUser () {
      if (this.userIsAdmin || this.userIsContextCompanyConsultant) {
        return ['owner', 'manager', 'visitor'];
      }
      return ['manager', 'visitor'];
    },
    addUserModal () {
      return this.$refs['invite-company-modal'];
    },
  },
  methods: {
    deleteUserForCompany (user) {
      this.$api.deleteCompanyUser(this.$route.params.id, user.id)
        .then(() => {
          this.$api.company(this.$route.params.id)
            .then((res) => {
              this.makeToast('success', 'Utente eliminato', 'Utente correttamente eliminato');
            });
        }).finally(() => {
          this.updateUsers();
        });
    },
    deleteReservation (user) {
      this.$api.deleteUserReservation(user.reservationId)
        .then(() => {
          this.$api.companyUsers(this.$route.params.id)
            .then((res) => {
              this.makeToast('success', 'Invito eliminato', 'Invito correttamente eliminato');
            });
        })
        .catch(err => {
          this.$log.debug(err);
        }).finally(() => {
          this.updateUsers();
        });
    },
    reserve (user) {
      this.$api.reserveUser({ ...user, company: this.$route.params.id }).then(() => {
        this.makeToast('success', 'Invito inviato', `Email correttamente inviata a ${user.email}`);
      }).catch(err => {
        this.$log.debug(err);
      }).finally(() => {
        this.updateUsers();
      });
    },
    makeToast (variant = null, title = '', content = 'Successo') {
      this.$bvToast.toast(content, {
        title: title,
        toaster: 'b-toaster-top-right',
        solid: true,
        variant: variant,
        appendToast: true,
      });
    },
    updateUsers () {
      this.$api.companyUsers(this.$route.params.id)
        .then((res) => {
          this.users = res.data.users;
        }).catch(err => {
          this.$log.debug(err);
        });
    },
    onReservedUser (user) {
      this.$api.company(this.$route.params.id)
        .then(res => {
          this.addUserModal.hide();
        })
        .catch(err => {
          this.$log.error(err);
        })
        .finally(() => {
          this.updateUsers();
        })
      ;
    },
  },
  async beforeRouteEnter (to, from, next) {
    try {
      const users = await $api.companyUsers(to.params.id);

      return next(vm => {
        vm.users = users?.data.users || null;
      });
    } catch (error) {
      return next(vm => vm.$log.error(error));
    }
  },
};

</script>

<style lang="scss">

</style>
